export const validarRegistroDeUsuario = (values) => {

    const parametrosAValidar = {
        nombre: {
            required: [true, 'el nombre es obligatorio'],
            max: [100, 'El nombre no puede tener más de 100 caracteres']
        },
        apellidos: {
            required: [true, 'Los apellidos son obligatorios'],
            max: [200, 'Longitud máxima: 200 caracteres']
        },
        correo: {
            required: [true, 'el correo es obligatorio'],
            unique: [true, 'El correo proporcionado ya existe']
        },
        password: {
            required: [true, 'La contraseña es obligatoria'],
            max: 100
        }
    }

    const resultado = Object.keys(values).map( valor => {
        const pruebas = parametrosAValidar[valor];
        console.log(pruebas)
        if( pruebas.required ) {
            if( values[valor].length <= 0 ) {
                return {
                    ok: false,
                    msg: 'El  '
                }
            }
        }
        return {

        }

    })

    


    return resultado;

}

export const validarCamposNuevoUsuario = (values) => {

    const { nombre, apellidos, correo, password } = values;
    const errores = [];

    if( !nombre || nombre.length <= 0 ) {
        errores.push({
            param: 'nombre',
            msg: 'El nombre es obligatorio'
        })
    } else if ( nombre.length > 100 ) {
        errores.push({
            param: 'nombre',
            msg: 'El nombre no puede ser mayor a 100 caracteres'
        })
    }

    if( !apellidos || apellidos.length <= 0 ) {
        errores.push({
            param: 'apellidos',
            msg: 'Apellidos son obligatorios'
        })
    } else if ( apellidos.length > 200 ) {
        errores.push({
            param: 'apellidos',
            msg: 'Los apellidos no puede ser mayor a 200 caracteres'
        })
    }

    if( !correo || correo.length <= 0 ) {
        errores.push({
            param: 'correo',
            msg: 'El correo es obligatorio'
        })
    }

    if ( !password || password.length <= 0 ){
        errores.push({
            param: 'password',
            msg: 'La contraseña es obligatoria'
        })
    }

    return errores;


}